<template>
  <div class="mb-3">
    <NewInfoCard :style="'normal'">
      <div>
        <div class="card-text">
          <div class="card-title">
            {{ street }} {{ apartment }}
            <span class="edit-title" @click="$emit('goToManualForm')">
              {{ t("EDIT") }}
            </span>
          </div>
          <span v-if="combinedCityRegion">
            {{ combinedCityRegion }}<br />
          </span>
          <span v-if="confirmStepConfig?.showRegion && region">
            {{ region }}<br />
          </span>
          <span v-if="confirmStepConfig?.showNeighborhood && neighborhood">
            {{ neighborhood }}<br />
          </span>
          <span v-if="confirmStepConfig?.showZipcode && postalCode">
            {{ postalCode }}<br />
          </span>
          <span v-if="confirmStepConfig?.showNotes && notes">
            {{ notes }}
          </span>
        </div>
      </div>
    </NewInfoCard>
  </div>
  <div
    class="pt-1"
    :class="{
      'keyboard-open': isKeyboardOpen && isValid,
      'button-active': isValid,
      'floating-btn': isFromApp,
      'px-3': isFromApp,
    }"
  >
    <Button
      id="btn-continue"
      class="text-start w-100"
      @click="$emit('submit')"
      :disabled="disableButton || cityError !== null || !cityValidationPassed"
    >
      <div class="text-white text-center my-auto fw-bold btn-text">
        <span>{{ t("ACCEPT") }}</span>
      </div>
    </Button>
  </div>
</template>

<script setup lang="ts">

import { useI18n } from "@/apps/credit-line/composables/useI18n";
import NewInfoCard from "@/apps/credit-line/components/CreditCard/ShippingAddress/NewInfoCard.vue";
import Button from "@/apps/credit-line/components/Button.vue";

interface ConfirmStepConfig {
  showZipcode?: boolean;
  showRegion?: boolean;
  showApartment?: boolean;
  showNeighborhood?: boolean;
  showNotes?: boolean;
}

const { t } = useI18n();
defineProps<{
  street: string;
  apartment?: string;
  combinedCityRegion?: string;
  neighborhood: string;
  region?: string;
  postalCode?: string;
  notes: string;
  disableButton: boolean;
  cityError: string | null;
  cityValidationPassed: boolean;
  isKeyboardOpen: boolean;
  isFromApp: boolean;
  confirmStepConfig?: ConfirmStepConfig;
}>();
defineEmits(["goToManualForm", "submit"]);
</script>

<style scoped>
.card-text {
  font-size: 16px;
  font-weight: 500;
  font-family: Inter;
  color: #111111;
  text-align: left;
  line-height: 24px;
}
.card-title {
  display: flex;
  justify-content: space-between;
}
.edit-title {
  font-size: 16px;
  font-weight: 500;
  font-family: Inter;
  color: #007c3b;
  text-align: right;
  line-height: 24px;
  cursor: pointer;
}
</style>
